import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Task extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="fondrt-task">
                    <div className="fondrt-task__wrapper">
                        <div className="fondrt-task__title">Цель проекта</div>
                        <div className="fondrt-task__text">
                            Сделать процесс восстановления прав обманутых дольщиков через сайт Фонда
                            технологичным и удобным, реализовав современный технический функционал в
                            сочетании с высокой отказоустойчивостью.
                        </div>

                        <img
                            className="fondrt-task__image"
                            src="/images/pic/fondrt/fondRTTask.png"
                            alt=""
                            loading="lazy"
                        />
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Task;
